<template>
  <div class="unsupported-desktop" v-if="showUnsupportedDesktop">
    <img class="unsupported-image" :src="require(`@/assets/pc-no-support-icon.svg`)">
    <div class="unsupported-title">
      להשלמת חיבור חשבון {{ source.displayName }}
      נצטרך לעבור למכשיר הנייד
    </div>
    <div class="unsupported-subtitle">
      החיבור נעשה בעזרת האפליקציה של בנק {{ source.displayName }} ולכן לא נתמך במחשב.
      <span class="bold">אפשר להמשיך בקלות בעזרת הלינק שיש לך ב-WhatsApp</span>
    </div>
  </div>
  <div v-else-if="source.openBanking" class="open-banking-credentials-details">
    <div class="page-content">
      <img v-if="showLogo" class="logo-image" :src="require(`@/assets/bank-logos/${source.logoFile}`)">
      <div class="title">
        לחיבור בקליק של חשבון הבנק לקריאה בלבד,  <span class="bold">{{ source.openBanking.title }}</span>
      </div>
      <ValidationObserver ref="observer" slim>
      <credentials-input-field class="input-container"
                               :field-name="'של מי החשבון? (שם)'"
                               :validations="'min-length:2'"
                               :error="nameAlreadyUsedError"
                               :error-message="nameAlreadyUsedErrorMessage"
                               :field-type="'text'"
                               :field-value="name"
                               :update-input="updateName"/>
      <credentials-input-field
                               class="input-container"
                               ref="identification"
                               :field-name="'מספר זהות'"
                               :field-type="'text'"
                               :field-value="credentials['idNumber']"
                               :validations="'id'"
                               :update-input="updateCredentials('idNumber')"/>
      </ValidationObserver>
      <div class="button-wrapper">
        <riseup-button
          class="save-button"
          :variant="'leumi'"
          :disabled="!buttonEnabled"
          :title="source.openBanking.buttonTitle"
          :action="saveOpenBanking"
          :size="'small'"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BaseUi from 'base-ui';
import _ from 'lodash';
import CredentialsInputField from '../CredentialsInputField.vue';
import RedirectToOpenBankingPopup from './RedirectToOpenBankingPopup.vue';
import Segment from '../../../Segment';

export default {
  name: 'OpenBankingDetails',
  components: {
    CredentialsInputField,
    RiseupButton: BaseUi.RiseupButton,
  },
  props: {
    source: {
      type: Object,
      required: true,
    },
    nameAlreadyUsedError: {
      type: Boolean,
      default: false,
    },
    setNameAlreadyInUseError: {
      type: Function,
    },
    validateName: {
      type: Function,
      required: true,
    },
    showLogo: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      credentials: {},
      name: '',
      showError: false,
    };
  },
  computed: {
    showUnsupportedDesktop() {
      return this.source && this.source.openBanking && !this.source.openBanking.allowDesktop && !this.isMobile();
    },
    isValidName() {
      return this.name.length > 1;
    },
    nameAlreadyUsedErrorMessage() {
      return this.nameAlreadyUsedError ? 'כבר השתמשת בשם הזה' : null;
    },
    isValidIdNumber() {
      return this.credentials.idNumber && this.credentials.idNumber.length > 8;
    },
    buttonEnabled() {
      return this.isValidName && this.isValidIdNumber;
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    isMobile() {
      const mobileAgents = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i,
      ];
      return _.some(mobileAgents, toMatchItem => navigator.userAgent.match(toMatchItem));
    },
    updateCredentials(fieldKey) {
      return value => {
        this.$set(this.credentials, fieldKey, value);
      };
    },
    updateName(name) {
      this.name = name;
      this.setNameAlreadyInUseError(false);
    },
    async saveOpenBanking() {
      this.showError = true;
      Segment.trackUserInteraction('OBKConnectClicked', { sourceName: this.source.sourceName });
      await this.validateName({ sourceName: this.source.sourceName, name: this.name });
      const valid = await this.$refs.observer.validate();
      this.$refs.identification.validate();
      if (valid && !this.nameAlreadyUsedError) {
        this.openModal({
          component: RedirectToOpenBankingPopup,
          props: {
            idNumber: this.credentials.idNumber,
            name: this.name,
            source: this.source,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../scss/mixins';

  .unsupported-desktop {
    padding: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    @include responsive-padding;
    .unsupported-image {
      width: 130px;
      height: 90px;
      margin: 50px auto;
    }
    .unsupported-title{
      font-size: 20px;
      line-height: 28px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .unsupported-subtitle{
      font-size: 18px;
      line-height: 26px;
      .bold {
        font-weight: bold;
      }
    }
  }
  .open-banking-credentials-details {
    width: 100%;

    .error-bar {
      @include responsive-padding;
    }

    .page-content {
      padding: 30px;
      @include responsive-padding;

      .logo-image {
        height: 40px;
        margin-bottom: 20px;
      }

      .title {
        color: $riseup_black;
        font-size: 18px;
        line-height: 1.44;
        margin-bottom: 30px;

        .bold {
          font-weight: bold;
        }
      }

      .tool-tip-wrapper {
        margin-bottom: 35px;
      }

      .input-container {
        margin-bottom: 30px;
      }

      .button-wrapper {
        .save-button {
          width: 100%;
        }
      }
    }
  }

</style>
